"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getBrowser = exports.BROWSER = exports.getOperatingSystem = exports.OPERATING_SYSTEM = exports.RESPONSIVE_BREAKPOINTS = void 0;
exports.RESPONSIVE_BREAKPOINTS = {
    small: 480,
    medium: 768,
    large: 1024
};
// keep this in lockstep with getOpertaingSystem
exports.OPERATING_SYSTEM = {
    windows: 'windows',
    apple: 'iOS/MacOS',
    android: 'Android'
};
const getOperatingSystem = () => {
    let operatingSystem = 'Windows';
    if (navigator.userAgent.match(/Windows/)) {
        operatingSystem = 'Windows';
    }
    else if (navigator.userAgent.match(/Macintosh/)) {
        operatingSystem = 'iOS/MacOS';
    }
    else if (navigator.userAgent.match(/Android/)) {
        operatingSystem = 'Android';
    }
    return operatingSystem;
};
exports.getOperatingSystem = getOperatingSystem;
// keep this in lockstep with getBrowser
exports.BROWSER = {
    chrome: 'Chrome',
    edge: 'Edge',
    firefox: 'Firefox',
    safari: 'Safari'
};
const getBrowser = () => {
    let browser = 'Chrome';
    if (navigator.userAgent.match(/Firefox/)) {
        browser = 'Firefox';
    }
    else if (navigator.userAgent.match(/Edg/)) {
        browser = 'Edge';
    }
    else if (navigator.userAgent.match(/Version/)) {
        browser = 'Safari';
    }
    // NOTE match Chrome last as the string 'Chrome' is also used in the Edge userAgent
    else if (navigator.userAgent.match(/Chrome/)) {
        browser = 'Chrome';
    }
    return browser;
};
exports.getBrowser = getBrowser;
//# sourceMappingURL=deviceUtils.js.map